export const CHECKING = 'CHECKING';
export const SAVINGS = 'SAVINGS';
export const PINLESS_DEBIT_CARD = 'PINLESS_DEBIT_CARD';
export const CREDIT_CARD = 'CREDIT_CARD';
